<!-- <i class="pi pi-times close-button" (click)="closePreview()"></i> -->
<pdf-viewer
  [src]="pdfBytes"
  [render-text]="false"
  [original-size]="false"
  [autoresize]="false"
  [show-borders]="true"
  style="height: 700px; max-height: 95vh; z-index: 1"
></pdf-viewer>
